<template>
  <b-card
    class="subscription-summary"
    :body-class="bodyClass"
    data-testid="subscription-summary-card"
  >
    <div class="text-center d-flex flex-column align-items-center">
      <h3 class="font-weight-bolder text-primary mb-1">
        {{ planName }}
      </h3>
      <b-badge
        :variant="statusVariant"
        pill
        class="subscription-summary__status"
        :class="{ 'order-first mb-1': statusFirst }"
        data-testid="subscription-status-badge"
      >
        <feather-icon
          :icon="statusIcon"
          size="16"
          class="mr-50"
        />
        {{ statusLabel }}
      </b-badge>
      <div
        v-if="accessDateLabel"
        class="text-muted mt-1"
        data-testid="subscription-access-date"
      >
        {{ accessDateLabel }}
      </div>
      <div
        v-if="remainingLabel"
        class="text-info font-weight-bold mt-50"
        data-testid="subscription-days-left"
      >
        {{ remainingLabel }}
      </div>
    </div>

    <hr class="subscription-summary__rule">

    <h5 class="text-center mb-2">
      {{ $t('subscription.packageContents') }}
    </h5>
    <ul class="list-unstyled mb-0">
      <li
        v-for="feature in features"
        :key="feature"
        class="subscription-summary__feature d-flex align-items-center"
      >
        <feather-icon
          icon="CheckCircleIcon"
          class="text-primary mr-1 flex-shrink-0"
          size="18"
        />
        <span class="font-weight-bold">{{ $t(feature) }}</span>
      </li>
    </ul>
  </b-card>
</template>

<script>
import { BCard, BBadge } from 'bootstrap-vue'

// PM 04.08.2026 items 7 and 8. This replaces three copies of a bare
// "Aylık Abonelik / Durum: TRIAL / Deneme sürenizin bitiş tarihi" text block
// that printed the raw status enum straight to the customer.
//
// Deliberately presentational: it receives an already-resolved label and
// variant rather than a subscriptionStatus, so the trial-reads-as-active
// decision stays in one place in Pricing.vue instead of being re-derived here.
export default {
  name: 'SubscriptionSummaryCard',
  components: { BCard, BBadge },
  props: {
    planName: {
      type: String,
      required: true,
    },
    statusLabel: {
      type: String,
      required: true,
    },
    statusVariant: {
      type: String,
      default: 'light-success',
    },
    statusIcon: {
      type: String,
      default: 'CheckCircleIcon',
    },
    accessDateLabel: {
      type: String,
      default: '',
    },
    remainingLabel: {
      type: String,
      default: '',
    },
    statusFirst: {
      type: Boolean,
      default: false,
    },
    bodyClass: {
      type: String,
      default: 'p-3 p-md-4',
    },
    features: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.subscription-summary__status {
  font-size: 1rem;
  padding: 0.6rem 1.25rem;
}

.subscription-summary__rule {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

/* Item 5's complaint about cramped feature rows applies here too -- this list
   is the same one the offer card renders. */
.subscription-summary__feature + .subscription-summary__feature {
  margin-top: 1rem;
}
</style>
